import { StatusCodes } from "http-status-codes";
import { ErrorService } from "../domain/services/ErrorService";
import { BehaviorSubject, Subscription } from "rxjs";
import { ApiResponseStatus } from "../domain/enums/common/ApiResponseStatusEnum";
import { ApiErrorSubject } from "../types/ApiResults";

export class ErrorServiceImpl implements ErrorService {
    private constructor() {}
    private static _instance: ErrorService;
    private static _errorResponseSubject =
        ErrorServiceImpl.getInitialErrorResponseSubject();

    private static getInitialErrorResponseSubject() {
        return new BehaviorSubject<ApiErrorSubject>({
            status: ApiResponseStatus.INITIAL,
            statusCode: null,
            errorKey: "",
        });
    }

    static getInstance() {
        if (!ErrorServiceImpl._instance) {
            ErrorServiceImpl._instance = new ErrorServiceImpl();
        }
        return ErrorServiceImpl._instance;
    }

    private notifyListeners(value: ApiErrorSubject): void {
        ErrorServiceImpl._errorResponseSubject.next(value);
    }

    subscribeOnError(
        onErrorCallback: (subject: ApiErrorSubject) => void
    ): Subscription {
        return ErrorServiceImpl._errorResponseSubject.subscribe((error) => {
            if (error && typeof onErrorCallback === "function") {
                onErrorCallback(error);
            }
        });
    }

    getApiErrorSubject(): ApiErrorSubject {
        return ErrorServiceImpl._errorResponseSubject.getValue();
    }

    handleResponseError(response: Response): void {
        switch (response.status) {
            case StatusCodes.OK:
                this.notifyListeners({
                    status: ApiResponseStatus.SUCCEEDED,
                    statusCode: response.status,
                    errorKey: "",
                });
                return;
            default:
                this.notifyListeners({
                    status: ApiResponseStatus.FAILED,
                    statusCode: response.status,
                    errorKey: `errors.response.${response.status}`,
                });
        }
        throw new Error(JSON.stringify(response.statusText));
    }

    resetErrorResponseSubject(): ApiErrorSubject {
        this.notifyListeners({
            status: ApiResponseStatus.INITIAL,
            statusCode: null,
            errorKey: "",
        });
        return this.getApiErrorSubject();
    }

    setLoadingSubjectState(): ApiErrorSubject {
        this.notifyListeners({
            status: ApiResponseStatus.LOADING,
            statusCode: null,
            errorKey: "",
        });
        return this.getApiErrorSubject();
    }
}

export function errorServiceFactory(): ErrorService {
    return ErrorServiceImpl.getInstance();
}
